<wiz-hgroup
  width="100%"
  height="100%"
  horizontalAlign="center"
  gap="2">
  
    <wiz-label
      #lbContent
      [wizLabel]="trsLabel"
      width="100%"
      padding="3px"
      [wizNbLine]="3"
      [wizTextBehavior]="'wordWrap'"
    ></wiz-label>

    <wiz-checkbox [wizValue]="visible" wizLabel="$.scen.main.$"></wiz-checkbox>
    <wiz-checkbox [wizValue]="editable" wizLabel="$.scen.shared.$"></wiz-checkbox>

    <wiz-label #lblBL [wizLabel]="data.nbBL" width="100%"></wiz-label>
    <wiz-label #lblBLV [wizLabel]="data.nbBLV" width="100%"></wiz-label>
</wiz-hgroup>
